import React, { useEffect } from 'react'
import { Grid, Typography, Card, CardContent, Avatar, Button, CircularProgress } from '@mui/material'
import { getBookedLessonById, deleteBookedLessonByAdmin, updatePaidForTeacherStatus } from '../../actions/learningScheduleForStudent'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import convertMillisecondsToMinutes from '../../utils/convertMillisecondsToMinutes'
import { Cloudinary } from '@cloudinary/url-gen'
import { Link, useHistory } from 'react-router-dom'
import { ArrowBack, DeleteForever, Payment } from '@mui/icons-material'
import { useConfirm } from 'material-ui-confirm'
import { toast } from 'react-toastify'
import displayBookedLessonEndingTimeForStudent from '../../utils/displayBookedLessonEndingTimeForStudent'

const BookedLessonDetails = ({ match }) => {

  const bookedLessonId = match.params.id

  const { bookedLesson, loading } = useSelector(state => state.learningScheduleForStudent)

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'youspeak'
    }
  })

  const confirm = useConfirm()

  let cldTeacherImageAvatar = ''
  if (bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.teacherAvatar) {
    const cldTeacherAvatar = cld.image(bookedLesson.profileTeacher.teacherAvatar)

    cldTeacherImageAvatar = cldTeacherAvatar.toURL()
  }

  let cldStudentImageAvatar = ''
  if (bookedLesson && bookedLesson.profileStudent && bookedLesson.profileStudent.imageAvatar) {
    const cldStudentAvatar = cld.image(bookedLesson.profileStudent.imageAvatar)

    cldStudentImageAvatar = cldStudentAvatar.toURL()
  }

  const history = useHistory()

  const dispatch = useDispatch()

  useEffect(() => { dispatch(getBookedLessonById(bookedLessonId)) }, [bookedLessonId, dispatch])

  const handleDelete = (bookedLessonId) => {
    confirm({
      description: 'Nhấn đồng ý sẽ xóa bài học',
      title: 'Bạn có chắc không?'
    }).then(() => {
      dispatch(deleteBookedLessonByAdmin(bookedLessonId))
      toast.success('Đã xóa bài học thành công')
      history.push('/admin/dashboard')
    }).catch(() => { })
  }

  const handlePay = (bookedLessonId) => {
    confirm({
      description: 'Nhấn đồng ý sẽ cập nhật trạng thái của bài học',
      title: 'Bạn có chắc không?'
    }).then(() => {
      dispatch(updatePaidForTeacherStatus(bookedLessonId))
      toast.success('Đã cập nhật trạng thái thanh toán thành công cho giáo viên')
      // history.push('/admin/dashboard')
    }).catch(() => { })
  }

  return (
    <Grid container direction='column' alignItems='center' spacing={3} style={{ width: '100%', margin: '0', padding: '0 4em', marginBottom: '2em' }}>
      <Grid item style={{ alignSelf: 'flex-start' }}>
        <Button variant='contained' component={Link} to='/admin/dashboard' style={{ color: 'white' }}>
          <ArrowBack style={{ color: 'white' }} /> Trở về
        </Button>
      </Grid>

      <Grid item>
        <Typography variant='h4' style={{ textTransform: 'uppercase' }}>Chi tiết bài học</Typography>
      </Grid>

      <Grid item>
        <Card>
          <CardContent>
            <Typography variant='h5' style={{ textAlign: 'center' }}>Thông tin của bài học</Typography>

            {loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></div> : <>
              <Typography variant='body1'><strong>Kiểu bài học: </strong> {bookedLesson && bookedLesson.lesson && bookedLesson.lesson.lessonName}</Typography>
              <Typography variant='body1'><strong>Tình trạng: </strong> {bookedLesson && bookedLesson.bookedTime && bookedLesson.bookedTime[0] && bookedLesson.state}</Typography>

              <Typography variant='body1'><strong>Thời gian bắt đầu: </strong> {bookedLesson && bookedLesson.bookedTime && bookedLesson.bookedTime[0] && moment(bookedLesson.bookedTime[0].start).format('HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY')}</Typography>

              <Typography variant='body1'><strong>Thời gian kết thúc: </strong> {bookedLesson && bookedLesson.bookedTime && bookedLesson.bookedTime[0] && bookedLesson.duration && displayBookedLessonEndingTimeForStudent(bookedLesson)}</Typography>

              <Typography variant='body1'><strong>Thời lượng: </strong> {bookedLesson && convertMillisecondsToMinutes(bookedLesson.duration)} phút</Typography>

              {bookedLesson && bookedLesson.complaint && bookedLesson.complaint.content && <Typography variant='body1'><strong>Nội dung khiếu nại của học sinh: </strong> {bookedLesson.complaint.content}</Typography>}

              {bookedLesson.complaint && <Typography variant='body1'><strong>Yêu cầu hoàn tiền: </strong> {bookedLesson.complaint.isRequestedRefund ? 'có' : 'không'}</Typography>}

              <Typography variant='body1'><strong>Trả phí cho giáo viên: </strong> {bookedLesson && bookedLesson.isPaidForTeacher && bookedLesson.isPaidForTeacher ? 'Rồi' : 'Chưa'}</Typography></>}

            {bookedLesson && bookedLesson.paidForTeacherDate && <Typography variant='body1'><strong>Thời gian trả phí cho giáo viên: </strong>{moment(bookedLesson.paidForTeacherDate).format(
              'HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY'
            )}</Typography>}
          </CardContent>
        </Card>
      </Grid>

      <Grid item>
        <Card>
          <CardContent>
            <Typography variant='h5' style={{ textAlign: 'center' }}>Thông tin của giáo viên</Typography>

            {loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></div> : <><Avatar src={cldTeacherImageAvatar ? cldTeacherImageAvatar : ''} style={{ width: '100px', height: '100px', margin: 'auto' }} />

              <Typography variant='body1'><strong>Tên: </strong> {bookedLesson && bookedLesson.teacher && bookedLesson.teacher.name}</Typography>

              <Typography variant='body1'><strong>Email: </strong> {bookedLesson && bookedLesson.teacher && bookedLesson.teacher.email}</Typography>

              {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.dateOfBirth && <Typography variant='body1' ><strong>Ngày tháng năm sinh: </strong> {moment(bookedLesson.profileTeacher.dateOfBirth).format('[ngày] DD, MMMM, YYYY')}</Typography>}

              {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.skypeId && <Typography variant='body1'><strong>Skype ID: </strong> {bookedLesson.profileTeacher.skypeId}</Typography>}

              {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.phoneNumber && <Typography variant='body1'><strong>Số điện thoại: </strong> {bookedLesson.profileTeacher.phoneNumber}</Typography>}

              {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.typeOfTeacher && <Typography variant='body1'><strong>Kiểu giáo viên: </strong> {bookedLesson.profileTeacher.typeOfTeacher}</Typography>}

              {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.bankName && <Typography variant='body1'><strong>Tên ngân hàng: </strong> {bookedLesson.profileTeacher.bankName}</Typography>}

              {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.nameOnCard && <Typography variant='body1'><strong>Tên chủ thẻ: </strong> {bookedLesson.profileTeacher.nameOnCard}</Typography>}

              {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.cardNumber && <Typography variant='body1'><strong>Số thẻ ngân hàng: </strong> {bookedLesson.profileTeacher.cardNumber}</Typography>}</>}

          </CardContent>
        </Card>
      </Grid>

      <Grid item>
        <Card>
          <CardContent>
            <Typography variant='h5' style={{ textAlign: 'center' }}>Thông tin của học sinh</Typography>

            {loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></div> : <><Avatar src={cldStudentImageAvatar ? cldStudentImageAvatar : ''} style={{ width: '100px', height: '100px', margin: 'auto' }} />

              {bookedLesson && bookedLesson.user && bookedLesson.user.name && <Typography variant='body1'><strong>Tên: </strong> {bookedLesson.user.name}</Typography>}

              {bookedLesson && bookedLesson.user && bookedLesson.user.email && <Typography variant='body1'><strong>Email: </strong> {bookedLesson.user.email}</Typography>}

              {bookedLesson && bookedLesson.profileStudent && bookedLesson.profileStudent.gender && <Typography variant='body1'><strong>Giới tính: </strong> {bookedLesson.profileStudent.gender}</Typography>}

              {bookedLesson && bookedLesson.profileStudent && bookedLesson.profileStudent.dateOfBirth && <Typography variant='body1'><strong>Ngày tháng năm sinh: </strong> {moment(bookedLesson.user.dateOfBirth).format('[ngày] DD, MMMM, YYYY')}</Typography>}

              {bookedLesson && bookedLesson.profileStudent && bookedLesson.profileStudent.skypeId && <Typography variant='body1'><strong>Skype ID: </strong> {bookedLesson.profileStudent.skypeId}</Typography>}

              {bookedLesson && bookedLesson.profileStudent && bookedLesson.profileStudent.phoneNumber && <Typography variant='body1'><strong>Số điện thoại: </strong> {bookedLesson.profileStudent.phoneNumber}</Typography>}</>}

          </CardContent>
        </Card>
      </Grid>

      <Grid item container justifyContent='center' alignItems='center' spacing={2}>
        <Grid item><Button variant='contained' color='secondary' style={{ color: 'white' }} onClick={() => handleDelete(bookedLesson._id)}><DeleteForever />&nbsp; Xóa bài học</Button></Grid>

        <Grid item><Button disabled={bookedLesson.isPaidForTeacher} variant='contained' color='primary' style={{ color: 'white' }} onClick={() => handlePay(bookedLesson._id)}><Payment />&nbsp; Trả phí</Button></Grid>
      </Grid>
    </Grid >
  );
}

export default BookedLessonDetails